import React from 'react';
import { FAQGlobalReference } from '@components/block-content/types/components/FAQGlobalReference/FAQGlobalReference';
import { FAQGlobalReferenceType } from '@appTypes/FAQGlobalReferenceType';

interface FAQGlobalReferenceBlockProps {
  block: FAQGlobalReferenceType;
}

export const FAQGlobalReferenceBlock = ({ block }: FAQGlobalReferenceBlockProps) => {
  if (!block) return null;
  return <FAQGlobalReference value={block} />;
};
